import axiosConfig from '../../packs/axios'

export default {
  methods: {
    // ...es6 destructuring...
    // https://hacks.mozilla.org/2015/05/es6-in-depth-destructuring/
    // { variable = value } --> that is setting a default value
    axiosMethod({ methodType = 'get', url, params, onSuccess, onError, onExtraParam, config = null}) {
      axiosConfig[methodType](url, params, config)
        .then((response) => onSuccess && onSuccess(response.data, onExtraParam) )
        .catch((error) => onError && onError(error, onExtraParam) )
    },
  },
}
